module.exports = new __parcel__URL__("controls.659c28b7.webp").toString();